import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import sentry from '@/services/sentry'

const countingEntries = (getters, {
  slide, perAnswerValue = true, histogram = false, answerer = false,
}, all = false) => {
  const base = { slideId: slide.id, slideVersion: slide.version }
  const keys = []
  const groups = []
  if (all || getters.canReadAnswertextFromCounting) {
    keys.push(CountingSchemes.answerCountPerActivity(base))
    if (perAnswerValue && !histogram) groups.push(CountingSchemes.answerCountPerAnswerValue(base))
  }
  if (answerer && (all || getters.canReadAnswererCountFromCounting)) {
    keys.push(CountingSchemes.answererCountPerQuestion({ ...base, questionId: 0 }))
  }
  if (histogram && (all || getters.canReadAnswerscoreHistogramFromCounting
    || getters.canReadAnswerscoreAverageFromCounting)) {
    groups.push(CountingSchemes.answerCountPerAnswerValue(base))
  }
  return { keys, groups }
}

const wanted = (getters, { histogram, answerer }) => getters.canReadAnswertextFromCounting
  || (answerer && getters.canReadAnswererCountFromCounting)
  || (histogram && (getters.canReadAnswerscoreHistogramFromCounting
    || getters.canReadAnswerscoreAverageFromCounting))

const SEED_RETRIES = 1

const report = (error) => sentry.captureException(error)

const reportTruncated = ({ path, count }) => report(
  new Error(`counting seed truncated at ${count} rows: ${path}`),
)

const countingActions = {
  subscribeCountingForSlideAction: ({ dispatch, getters }, payload) => {
    if (!payload?.slide?.id || !wanted(getters, payload)) return
    try {
      dispatch('counting/subscribe', {
        ...countingEntries(getters, payload),
        retries: SEED_RETRIES,
        onError: report,
        onTruncated: reportTruncated,
      }, { root: true }).catch(report)
    } catch (error) {
      report(error)
    }
  },

  unsubscribeCountingForSlideAction: ({ dispatch, getters }, payload) => {
    if (!payload?.slide?.id) return
    try {
      dispatch('counting/unsubscribe', countingEntries(getters, payload, true), { root: true })
    } catch (error) {
      report(error)
    }
  },
}

export default countingActions
